// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/validationpb/v1/validation.proto (package unacast.boundaries.validationpb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { TypesetGroup } from "../../typesetpb/v1/typeset_pb.js";

/**
 * @generated from enum unacast.boundaries.validationpb.v1.FailureType
 */
export enum FailureType {
  /**
   * @generated from enum value: FAILURE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FAILURE_TYPE_FIELD_VALIDATION = 1;
   */
  FIELD_VALIDATION = 1,

  /**
   * @generated from enum value: FAILURE_TYPE_GEOMETRY_VALIDATION = 2;
   */
  GEOMETRY_VALIDATION = 2,

  /**
   * Deprecated
   *
   * @generated from enum value: FAILURE_TYPE_DUPLICATES_VALIDATION = 3;
   */
  DUPLICATES_VALIDATION = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(FailureType)
proto3.util.setEnumType(FailureType, "unacast.boundaries.validationpb.v1.FailureType", [
  { no: 0, name: "FAILURE_TYPE_UNSPECIFIED" },
  { no: 1, name: "FAILURE_TYPE_FIELD_VALIDATION" },
  { no: 2, name: "FAILURE_TYPE_GEOMETRY_VALIDATION" },
  { no: 3, name: "FAILURE_TYPE_DUPLICATES_VALIDATION" },
]);

/**
 * @generated from message unacast.boundaries.validationpb.v1.FieldValidation
 */
export class FieldValidation extends Message<FieldValidation> {
  /**
   * @generated from field: bool require_value = 1;
   */
  requireValue = false;

  /**
   * @generated from field: optional unacast.boundaries.validationpb.v1.FieldValidation.TypesetValidation typeset = 2;
   */
  typeset?: FieldValidation_TypesetValidation;

  /**
   * @generated from field: optional unacast.boundaries.validationpb.v1.FieldValidation.TypesetTypeValidation typeset_type = 3;
   */
  typesetType?: FieldValidation_TypesetTypeValidation;

  /**
   * Potentially very slow
   *
   * e.g. ^[A-Z]\w+$
   *
   * @generated from field: optional string regular_expression = 10;
   */
  regularExpression?: string;

  constructor(data?: PartialMessage<FieldValidation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.FieldValidation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "require_value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "typeset", kind: "message", T: FieldValidation_TypesetValidation, opt: true },
    { no: 3, name: "typeset_type", kind: "message", T: FieldValidation_TypesetTypeValidation, opt: true },
    { no: 10, name: "regular_expression", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FieldValidation {
    return new FieldValidation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FieldValidation {
    return new FieldValidation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FieldValidation {
    return new FieldValidation().fromJsonString(jsonString, options);
  }

  static equals(a: FieldValidation | PlainMessage<FieldValidation> | undefined, b: FieldValidation | PlainMessage<FieldValidation> | undefined): boolean {
    return proto3.util.equals(FieldValidation, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.FieldValidation.TypesetValidation
 */
export class FieldValidation_TypesetValidation extends Message<FieldValidation_TypesetValidation> {
  /**
   * @generated from field: unacast.boundaries.typesetpb.v1.TypesetGroup typeset_group = 1;
   */
  typesetGroup = TypesetGroup.UNSPECIFIED;

  /**
   * @generated from field: repeated string typesets = 2;
   */
  typesets: string[] = [];

  constructor(data?: PartialMessage<FieldValidation_TypesetValidation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.FieldValidation.TypesetValidation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "typeset_group", kind: "enum", T: proto3.getEnumType(TypesetGroup) },
    { no: 2, name: "typesets", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FieldValidation_TypesetValidation {
    return new FieldValidation_TypesetValidation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FieldValidation_TypesetValidation {
    return new FieldValidation_TypesetValidation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FieldValidation_TypesetValidation {
    return new FieldValidation_TypesetValidation().fromJsonString(jsonString, options);
  }

  static equals(a: FieldValidation_TypesetValidation | PlainMessage<FieldValidation_TypesetValidation> | undefined, b: FieldValidation_TypesetValidation | PlainMessage<FieldValidation_TypesetValidation> | undefined): boolean {
    return proto3.util.equals(FieldValidation_TypesetValidation, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.FieldValidation.TypesetTypeValidation
 */
export class FieldValidation_TypesetTypeValidation extends Message<FieldValidation_TypesetTypeValidation> {
  /**
   * @generated from field: string typeset = 1;
   */
  typeset = "";

  constructor(data?: PartialMessage<FieldValidation_TypesetTypeValidation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.FieldValidation.TypesetTypeValidation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "typeset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FieldValidation_TypesetTypeValidation {
    return new FieldValidation_TypesetTypeValidation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FieldValidation_TypesetTypeValidation {
    return new FieldValidation_TypesetTypeValidation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FieldValidation_TypesetTypeValidation {
    return new FieldValidation_TypesetTypeValidation().fromJsonString(jsonString, options);
  }

  static equals(a: FieldValidation_TypesetTypeValidation | PlainMessage<FieldValidation_TypesetTypeValidation> | undefined, b: FieldValidation_TypesetTypeValidation | PlainMessage<FieldValidation_TypesetTypeValidation> | undefined): boolean {
    return proto3.util.equals(FieldValidation_TypesetTypeValidation, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.GeometryValidation
 */
export class GeometryValidation extends Message<GeometryValidation> {
  /**
   * @generated from field: bool no_multi_polygons = 1;
   */
  noMultiPolygons = false;

  /**
   * @generated from field: bool no_overlapping_lines = 2;
   */
  noOverlappingLines = false;

  /**
   * @generated from field: optional int32 minimum_area = 3;
   */
  minimumArea?: number;

  /**
   * @generated from field: optional int32 maximum_area = 4;
   */
  maximumArea?: number;

  /**
   *  bool no_sensitive_locations = 4;
   *
   * @generated from field: optional string container_polygon = 20;
   */
  containerPolygon?: string;

  constructor(data?: PartialMessage<GeometryValidation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.GeometryValidation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "no_multi_polygons", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "no_overlapping_lines", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "minimum_area", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "maximum_area", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 20, name: "container_polygon", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GeometryValidation {
    return new GeometryValidation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GeometryValidation {
    return new GeometryValidation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GeometryValidation {
    return new GeometryValidation().fromJsonString(jsonString, options);
  }

  static equals(a: GeometryValidation | PlainMessage<GeometryValidation> | undefined, b: GeometryValidation | PlainMessage<GeometryValidation> | undefined): boolean {
    return proto3.util.equals(GeometryValidation, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.DuplicatesValidation
 */
export class DuplicatesValidation extends Message<DuplicatesValidation> {
  /**
   * @generated from field: bool unique_ids = 1;
   */
  uniqueIds = false;

  /**
   * @generated from field: bool unique_polygons = 2;
   */
  uniquePolygons = false;

  /**
   * @generated from field: bool unique_addresses = 3;
   */
  uniqueAddresses = false;

  /**
   * Deprecated: no longer used. Group threshold is now a hardcoded server-side constant.
   *
   * @generated from field: int64 max_duplicate_boundaries = 4 [deprecated = true];
   * @deprecated
   */
  maxDuplicateBoundaries = protoInt64.zero;

  constructor(data?: PartialMessage<DuplicatesValidation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.DuplicatesValidation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unique_ids", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "unique_polygons", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "unique_addresses", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "max_duplicate_boundaries", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DuplicatesValidation {
    return new DuplicatesValidation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DuplicatesValidation {
    return new DuplicatesValidation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DuplicatesValidation {
    return new DuplicatesValidation().fromJsonString(jsonString, options);
  }

  static equals(a: DuplicatesValidation | PlainMessage<DuplicatesValidation> | undefined, b: DuplicatesValidation | PlainMessage<DuplicatesValidation> | undefined): boolean {
    return proto3.util.equals(DuplicatesValidation, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.ValidationSpec
 */
export class ValidationSpec extends Message<ValidationSpec> {
  /**
   * @generated from field: map<string, unacast.boundaries.validationpb.v1.FieldValidation> fields = 1;
   */
  fields: { [key: string]: FieldValidation } = {};

  /**
   * @generated from field: unacast.boundaries.validationpb.v1.GeometryValidation geometry = 2;
   */
  geometry?: GeometryValidation;

  /**
   * @generated from field: unacast.boundaries.validationpb.v1.DuplicatesValidation duplicates = 3;
   */
  duplicates?: DuplicatesValidation;

  constructor(data?: PartialMessage<ValidationSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.ValidationSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fields", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: FieldValidation} },
    { no: 2, name: "geometry", kind: "message", T: GeometryValidation },
    { no: 3, name: "duplicates", kind: "message", T: DuplicatesValidation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidationSpec {
    return new ValidationSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidationSpec {
    return new ValidationSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidationSpec {
    return new ValidationSpec().fromJsonString(jsonString, options);
  }

  static equals(a: ValidationSpec | PlainMessage<ValidationSpec> | undefined, b: ValidationSpec | PlainMessage<ValidationSpec> | undefined): boolean {
    return proto3.util.equals(ValidationSpec, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.FieldFailure
 */
export class FieldFailure extends Message<FieldFailure> {
  /**
   * @generated from field: string field = 1;
   */
  field = "";

  /**
   * @generated from field: unacast.boundaries.validationpb.v1.FieldValidation validation = 2;
   */
  validation?: FieldValidation;

  constructor(data?: PartialMessage<FieldFailure>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.FieldFailure";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "validation", kind: "message", T: FieldValidation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FieldFailure {
    return new FieldFailure().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FieldFailure {
    return new FieldFailure().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FieldFailure {
    return new FieldFailure().fromJsonString(jsonString, options);
  }

  static equals(a: FieldFailure | PlainMessage<FieldFailure> | undefined, b: FieldFailure | PlainMessage<FieldFailure> | undefined): boolean {
    return proto3.util.equals(FieldFailure, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.GeometryFailure
 */
export class GeometryFailure extends Message<GeometryFailure> {
  /**
   * @generated from field: unacast.boundaries.validationpb.v1.GeometryValidation validation = 1;
   */
  validation?: GeometryValidation;

  constructor(data?: PartialMessage<GeometryFailure>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.GeometryFailure";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "validation", kind: "message", T: GeometryValidation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GeometryFailure {
    return new GeometryFailure().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GeometryFailure {
    return new GeometryFailure().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GeometryFailure {
    return new GeometryFailure().fromJsonString(jsonString, options);
  }

  static equals(a: GeometryFailure | PlainMessage<GeometryFailure> | undefined, b: GeometryFailure | PlainMessage<GeometryFailure> | undefined): boolean {
    return proto3.util.equals(GeometryFailure, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.DuplicatesFailure
 */
export class DuplicatesFailure extends Message<DuplicatesFailure> {
  /**
   * @generated from field: unacast.boundaries.validationpb.v1.DuplicatesValidation validation = 1;
   */
  validation?: DuplicatesValidation;

  /**
   * Reference to the duplicate_group for frontend linking
   *
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  /**
   * The hash of the duplicate value (used by FSM to find all boundaries with same hash)
   *
   * @generated from field: string duplicate_hash = 3;
   */
  duplicateHash = "";

  constructor(data?: PartialMessage<DuplicatesFailure>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.DuplicatesFailure";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "validation", kind: "message", T: DuplicatesValidation },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "duplicate_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DuplicatesFailure {
    return new DuplicatesFailure().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DuplicatesFailure {
    return new DuplicatesFailure().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DuplicatesFailure {
    return new DuplicatesFailure().fromJsonString(jsonString, options);
  }

  static equals(a: DuplicatesFailure | PlainMessage<DuplicatesFailure> | undefined, b: DuplicatesFailure | PlainMessage<DuplicatesFailure> | undefined): boolean {
    return proto3.util.equals(DuplicatesFailure, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.validationpb.v1.Failure
 */
export class Failure extends Message<Failure> {
  /**
   * @generated from field: unacast.boundaries.validationpb.v1.FailureType type = 1;
   */
  type = FailureType.UNSPECIFIED;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string client_provided_id = 3;
   */
  clientProvidedId = "";

  /**
   * @generated from oneof unacast.boundaries.validationpb.v1.Failure.failure
   */
  failure: {
    /**
     * @generated from field: unacast.boundaries.validationpb.v1.FieldFailure field = 10;
     */
    value: FieldFailure;
    case: "field";
  } | {
    /**
     * @generated from field: unacast.boundaries.validationpb.v1.GeometryFailure geometry = 11;
     */
    value: GeometryFailure;
    case: "geometry";
  } | {
    /**
     * Deprecated
     *
     * @generated from field: unacast.boundaries.validationpb.v1.DuplicatesFailure duplicates = 12;
     */
    value: DuplicatesFailure;
    case: "duplicates";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Failure>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.Failure";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(FailureType) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "client_provided_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "field", kind: "message", T: FieldFailure, oneof: "failure" },
    { no: 11, name: "geometry", kind: "message", T: GeometryFailure, oneof: "failure" },
    { no: 12, name: "duplicates", kind: "message", T: DuplicatesFailure, oneof: "failure" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Failure {
    return new Failure().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Failure {
    return new Failure().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Failure {
    return new Failure().fromJsonString(jsonString, options);
  }

  static equals(a: Failure | PlainMessage<Failure> | undefined, b: Failure | PlainMessage<Failure> | undefined): boolean {
    return proto3.util.equals(Failure, a, b);
  }
}

/**
 * Failures is to group multiple failures for a single boundary
 *
 * @generated from message unacast.boundaries.validationpb.v1.Failures
 */
export class Failures extends Message<Failures> {
  /**
   * @generated from field: repeated unacast.boundaries.validationpb.v1.Failure failures = 1;
   */
  failures: Failure[] = [];

  constructor(data?: PartialMessage<Failures>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.Failures";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "failures", kind: "message", T: Failure, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Failures {
    return new Failures().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Failures {
    return new Failures().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Failures {
    return new Failures().fromJsonString(jsonString, options);
  }

  static equals(a: Failures | PlainMessage<Failures> | undefined, b: Failures | PlainMessage<Failures> | undefined): boolean {
    return proto3.util.equals(Failures, a, b);
  }
}

/**
 * DuplicateGroup represents a group of boundaries that share the same duplicate key
 *
 * @generated from message unacast.boundaries.validationpb.v1.DuplicateGroup
 */
export class DuplicateGroup extends Message<DuplicateGroup> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Type of duplicate: "id", "polygon", or "address"
   *
   * @generated from field: string duplicate_type = 2;
   */
  duplicateType = "";

  /**
   * List of boundary IDs in this duplicate group (may be truncated if group is large)
   *
   * @generated from field: repeated string boundary_ids = 3;
   */
  boundaryIds: string[] = [];

  /**
   * The actual value that caused the duplicate (client_provided_id, address, or polygon hash)
   *
   * @generated from field: string duplicate_value = 4;
   */
  duplicateValue = "";

  /**
   * True if the boundary_ids list was truncated due to exceeding max group size
   *
   * @generated from field: bool is_truncated = 5;
   */
  isTruncated = false;

  /**
   * Total number of boundaries in this group (before truncation)
   *
   * @generated from field: int64 total_count = 6;
   */
  totalCount = protoInt64.zero;

  constructor(data?: PartialMessage<DuplicateGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.DuplicateGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "duplicate_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "boundary_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "duplicate_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_truncated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "total_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DuplicateGroup {
    return new DuplicateGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DuplicateGroup {
    return new DuplicateGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DuplicateGroup {
    return new DuplicateGroup().fromJsonString(jsonString, options);
  }

  static equals(a: DuplicateGroup | PlainMessage<DuplicateGroup> | undefined, b: DuplicateGroup | PlainMessage<DuplicateGroup> | undefined): boolean {
    return proto3.util.equals(DuplicateGroup, a, b);
  }
}

/**
 * DuplicateSummary contains summary statistics about duplicate detection
 *
 * @generated from message unacast.boundaries.validationpb.v1.DuplicateSummary
 */
export class DuplicateSummary extends Message<DuplicateSummary> {
  /**
   * Total number of duplicate groups detected
   *
   * @generated from field: int64 total_groups = 1;
   */
  totalGroups = protoInt64.zero;

  /**
   * Total number of boundaries involved in any duplicate group
   *
   * @generated from field: int64 total_boundaries_in_duplicates = 2;
   */
  totalBoundariesInDuplicates = protoInt64.zero;

  /**
   * True if the number of duplicate groups exceeded the group count threshold
   *
   * @generated from field: bool threshold_exceeded = 3;
   */
  thresholdExceeded = false;

  /**
   * The group count threshold that was used (e.g. 1000)
   *
   * @generated from field: int64 threshold = 4;
   */
  threshold = protoInt64.zero;

  /**
   * Number of sample groups retained when threshold_exceeded is true (e.g. 100)
   *
   * @generated from field: int64 sample_size = 5;
   */
  sampleSize = protoInt64.zero;

  constructor(data?: PartialMessage<DuplicateSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.validationpb.v1.DuplicateSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_groups", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "total_boundaries_in_duplicates", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "threshold_exceeded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "threshold", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "sample_size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DuplicateSummary {
    return new DuplicateSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DuplicateSummary {
    return new DuplicateSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DuplicateSummary {
    return new DuplicateSummary().fromJsonString(jsonString, options);
  }

  static equals(a: DuplicateSummary | PlainMessage<DuplicateSummary> | undefined, b: DuplicateSummary | PlainMessage<DuplicateSummary> | undefined): boolean {
    return proto3.util.equals(DuplicateSummary, a, b);
  }
}

